import { render, staticRenderFns } from "./IconChangeIframe.vue?vue&type=template&id=51ac5eea&"
import script from "./IconChangeIframe.vue?vue&type=script&lang=ts&"
export * from "./IconChangeIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports